export enum OAuth2ProviderName
{
    GOOGLE = 'google',
    FACEBOOK = 'facebook',
    MICROSOFT = 'microsoft',
    FINASTRA = 'finastra',
    OKTA = 'okta'
}
